import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { UtilitiesService } from '../../services/utilities.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import door from './door.json';
import glove from "./glove.json";
import { CfaService } from '../../services/cfa.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-first-subscribers',
    standalone: true,
    imports: [
        CommonModule,
        LottieComponent
    ],
    templateUrl: './first-subscribers.component.html',
    styleUrl: './first-subscribers.component.scss',
    animations: [
        trigger("fadeIn", [
            transition(":enter", [
                style({ opacity: 0 }),
                animate("500ms ease-in", style({ opacity: 1 })),
            ]),
        ]),
        trigger("slideInFromRight", [
            state(
                "void",
                style({
                    transform: "translateX(100%)",
                    opacity: 0,
                })
            ),
            state(
                "*",
                style({
                    transform: "translateX(0)",
                    opacity: 1,
                })
            ),
            transition(":enter", [animate("600ms ease-in")]),
        ])
    ]
})
export class FirstSubscribersComponent implements AfterViewInit {

    @Output()
    finished: EventEmitter<void> = new EventEmitter<void>();

    mascotImage: string;
    cardsVisible = false;
    gloveMode: boolean = false;

    doorOptions: AnimationOptions = {
        animationData: door,
        loop: true,
        autoplay: false
    }

    gloveOptions: AnimationOptions = {
        animationData: glove,
        loop: true,
        autoplay: true
    }

    img: string = "https://res.cloudinary.com/dap6pju8g/image/upload/v1741816769/Group_261_wfvga5.png";

    constructor(
        private readonly _utilities: UtilitiesService,
        private readonly _cdr: ChangeDetectorRef,
        private readonly _cfaService: CfaService
    ) {
        this.mascotImage = this._utilities.getMascotImage();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.cardsVisible = true;
            this._cdr.detectChanges();
        }, 1000);
    }

    continue() {
        this.gloveMode = true;
    }

    async finish() {
        await firstValueFrom(
            this._cfaService.confirmFirstSubscribers()
        );
        this.finished.emit();
    }
}
